import axiosConfig from './axiosConfig';

// List checklist items
export const getChecklistItemList = async (queryParams = {}) => {
    try {
        const response = await axiosConfig.get('checklistitem', { params: queryParams });
        return response;
    } catch (error) {
        throw error;
    }
};

// Create checklist item
export const createChecklistItem = async (itemData) => {
    try {
        const response = await axiosConfig.post('checklistitem', itemData, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response;
    } catch (error) {
        throw error || 'Failed to create checklist item';
    }
};

// Show checklist item details
export const getChecklistItem = async (id) => {
    try {
        const response = await axiosConfig.get(`checklistitem/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};

// Update checklist item
export const updateChecklistItem = async (id, itemData) => {
    try {
        const response = await axiosConfig.put(`checklistitem/${id}`, itemData, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response;
    } catch (error) {
        throw error || 'Failed to update checklist item';
    }
};

// Delete checklist item
export const deleteChecklistItem = async (id) => {
    try {
        const response = await axiosConfig.delete(`checklistitem/${id}`);
        return response;
    } catch (error) {
        throw error || 'Failed to delete checklist item';
    }
};